"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.875 5.417A2.415 2.415 0 0 1 10.287 3h3.426a2.415 2.415 0 0 1 2.412 2.417v3.435l-.002.106c-.003 2.956-.146 5.916-1.122 8.152-.502 1.152-1.236 2.14-2.305 2.834C11.629 20.637 10.284 21 8.624 21a.7.7 0 1 1 0-1.4c1.454 0 2.518-.317 3.31-.83.79-.514 1.366-1.261 1.784-2.22.64-1.466.885-3.36.968-5.486a2.4 2.4 0 0 1-.973.205h-3.426a2.415 2.415 0 0 1-2.412-2.417z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ThousandsIcon24.js.map